<template>
  <div>
    <publicAddress></publicAddress>
  </div>
 </template>
 <script>
 import publicAddress from '@/views/newTMS/publicFiles/publicAddress.vue'
 export default {
   components: {
     publicAddress
   },
   data () {
     return {
     }
   },
   created () {
   },
   mounted () {
   },
   methods: {
   }
 }
 </script>
 <style scoped lang='less'>
 </style>